import { Form, Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import mask from '../../utils/mask';
import { ParceiroProps } from './props';

const SelectParceiro: React.FC<ParceiroProps> = ({ setParceiro, label, name }) => {
  const parceiro = useSelector((state: ApplicationState) => state.auth.user?.inscricoesEstaduais);
  const { Option } = Select;

  const onChangeParc = (values: any) => {
    setParceiro(values);
    localStorage.setItem(`codParceiro${window.location.pathname}`, values);
  };

  const children = [];
  children.push(
    parceiro?.map((inscData, index) => (
      <Option
        data-cy="listOption"
        title={inscData.nomeParceiro}
        className="optionselect"
        value={inscData.codParceiro}
        key={inscData.codParceiro}
      >
        CNPJ/CPF: {mask('cpfCnpj', inscData.cnpjcpf)} <br />
        Inscrição estadual: {inscData.inscricaoEstadual} <br />
        Nome: {inscData.nomeParceiro} - Código: {inscData.codParceiro}
        <hr />
      </Option>
    ))
  );
  const localStorageItensPersist =
    localStorage.getItem(`codDepositante${window.location.pathname}`) || '';
  return (
    <>
      <Form.Item
        label={label}
        name={name ? name : 'parceiro'}
        rules={[{ required: true, message: 'Por favor preencha este campo' }]}
      >
        <Select
          data-cy="clienteFinal"
          showSearch
          style={{ width: '100%' }}
          filterOption={(inputValue, element) =>
            element?.props.children
              .toString()

              .toLowerCase()
              .includes(inputValue.toLowerCase())
          }
          onChange={onChangeParc}
          defaultValue={localStorageItensPersist}
        >
          {children}
        </Select>
      </Form.Item>
    </>
  );
};

export default SelectParceiro;
